var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "color-sample-combinations mb-5" }, [
    _c("div", { staticClass: "baumitlife-combination row pt-5" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("h2", { staticClass: "mb-5 mt-5" }, [
          _vm._v(_vm._s(_vm.trans("sample_order_color_combinations"))),
        ]),
        _c(
          "div",
          { staticClass: "row px-1" },
          _vm._l(_vm.combinations, function (combination, index) {
            return _c(
              "div",
              {
                key: "combination_" + index,
                staticClass: "col-sm-6 col-xs-12 baumitlife-combination-item",
              },
              [
                _c(
                  "div",
                  { staticClass: "row m-0" },
                  _vm._l(combination, function (color, index2) {
                    return _c(
                      "div",
                      {
                        key: "combination_color_" + index2,
                        staticClass: "col p-0",
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "card-item color-card-item color-card-item-small",
                            attrs: { "data-card-id": color.card.id },
                          },
                          [
                            _c("div", { staticClass: "inner" }, [
                              _c("div", {
                                staticClass: "color-card-color-background",
                                style: {
                                  background:
                                    color.hex && color.hex.length > 0
                                      ? (color.hex.substring(0, 1) != "#"
                                          ? "#"
                                          : "") + color.hex
                                      : "url(" + color.image + ")",
                                },
                              }),
                              _c(
                                "div",
                                { staticClass: "color-card-detail" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "inline-extra-icon" },
                                    [
                                      _c("div", { staticClass: "extra" }, [
                                        _c(
                                          "i",
                                          {
                                            staticClass:
                                              "actionToggleDashboard material-icons ",
                                            attrs: {
                                              "data-card-id": color.card.id,
                                              "data-add-url":
                                                "/myBaumit/ajaxAddCardToDashboard",
                                              "data-delete-url":
                                                "/myBaumit/ajaxDeleteCardFromDashboard",
                                              "data-added-to-dashboard": "0",
                                            },
                                          },
                                          [_vm._v("star_border")]
                                        ),
                                        color.isAvailableInSampleOrder
                                          ? _c(
                                              "a",
                                              {
                                                staticClass: "addtoCartButton",
                                                attrs: { href: "javascript:;" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.addToCart(
                                                      color.id
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "fa fa-cart-plus mr-2",
                                                }),
                                                _vm._v(" "),
                                                false
                                                  ? _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.trans(
                                                            "sample_order_addtocart_button"
                                                          )
                                                        )
                                                      ),
                                                    ])
                                                  : _vm._e(),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]),
                                    ]
                                  ),
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.trans("products_color_code")) +
                                      " "
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "color-card-title" },
                                    [_vm._v(" " + _vm._s(color.name) + " ")]
                                  ),
                                  color.hex && color.hex.length > 0
                                    ? [
                                        _vm._v(" HEX: #" + _vm._s(color.hex)),
                                        _c("br"),
                                      ]
                                    : _vm._e(),
                                  color.rgb_r && color.rgb_r.length > 0
                                    ? [
                                        _vm._v(
                                          " RGB: " +
                                            _vm._s(
                                              color.rgb_r +
                                                "/" +
                                                color.rgb_g +
                                                "/".color.rgb_b
                                            )
                                        ),
                                        _c("br"),
                                      ]
                                    : _vm._e(),
                                  color.hbw
                                    ? [
                                        _vm._v(" HBW: " + _vm._s(color.hbw)),
                                        _c("br"),
                                      ]
                                    : _vm._e(),
                                ],
                                2
                              ),
                            ]),
                          ]
                        ),
                      ]
                    )
                  }),
                  0
                ),
              ]
            )
          }),
          0
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }